module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/znamenka-a-kozni-vyrustky_3_before_tn.jpg
// module id = 1478
// module chunks = 0